import { useState } from 'react';
import { Link } from 'react-router-dom';
import SearchModal from '../../components/feature/SearchModal';
import { useCart } from '../../context/CartContext';
import { useWishlist } from '../../context/WishlistContext';

export default function TermsPage() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [collectionDropdownOpen, setCollectionDropdownOpen] = useState(false);
  const [searchModalOpen, setSearchModalOpen] = useState(false);
  const { totalItems } = useCart();
  const { totalItems: wishlistTotal } = useWishlist();

  return (
    <div className="min-h-screen bg-white">
      <SearchModal isOpen={searchModalOpen} onClose={() => setSearchModalOpen(false)} />
      
      {/* Top Navigation */}
      <nav className="fixed top-0 left-0 right-0 bg-white z-50 border-b border-black/10">
        <div className="px-6 py-4 flex items-center justify-between">
          {/* Mobile Menu Toggle */}
          <button 
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="md:hidden w-6 h-6 flex flex-col justify-center cursor-pointer"
          >
            <span className={`block w-full h-0.5 bg-black transition-all ${mobileMenuOpen ? 'rotate-45 translate-y-1' : 'mb-1'}`}></span>
            <span className={`block w-full h-0.5 bg-black transition-all ${mobileMenuOpen ? 'opacity-0' : 'mb-1'}`}></span>
            <span className={`block w-full h-0.5 bg-black transition-all ${mobileMenuOpen ? '-rotate-45 -translate-y-1' : ''}`}></span>
          </button>

          {/* Logo in center for both mobile and desktop */}
          <Link to="/" className="cursor-pointer absolute left-1/2 transform -translate-x-1/2">
            <img 
              src="https://static.readdy.ai/image/6ad45fecb24f9c50dfb1488fc3ba7d2f/1bfa6c5bfe10d7e974b284f405d55895.png" 
              alt="DASHY" 
              className="h-7 md:h-8"
            />
          </Link>
          
          {/* Desktop: Menu items on left */}
          <div className="hidden md:flex items-center gap-8">
            <Link to="/shop" className="text-sm tracking-[0.2em] hover:opacity-60 transition-opacity cursor-pointer">NEW ARRIVALS</Link>
            <div 
              className="relative"
              onMouseEnter={() => setCollectionDropdownOpen(true)}
              onMouseLeave={() => setCollectionDropdownOpen(false)}
            >
              <button className="text-sm tracking-[0.2em] hover:opacity-60 transition-opacity cursor-pointer flex items-center gap-1">
                COLLECTION
                <i className="ri-arrow-down-s-line text-lg"></i>
              </button>
              {collectionDropdownOpen && (
                <div className="absolute top-full left-0 pt-2">
                  <div className="bg-white border border-black/10 py-2 min-w-[160px] shadow-lg">
                    <Link to="/shop?category=hoodies" className="block px-6 py-2 text-sm tracking-[0.2em] hover:bg-neutral-50 cursor-pointer">
                      HOODIES
                    </Link>
                    <Link to="/shop?category=tees" className="block px-6 py-2 text-sm tracking-[0.2em] hover:bg-neutral-50 cursor-pointer">
                      T-SHIRTS
                    </Link>
                  </div>
                </div>
              )}
            </div>
            <Link to="/about" className="text-sm tracking-[0.2em] hover:opacity-60 transition-opacity cursor-pointer">ABOUT</Link>
          </div>
          
          {/* Icons on right */}
          <div className="flex items-center gap-4">
            <button 
              onClick={() => setSearchModalOpen(true)}
              className="w-10 h-10 hidden md:flex items-center justify-center cursor-pointer"
            >
              <i className="ri-search-line text-xl"></i>
            </button>
            <Link to="/wishlist" className="w-10 h-10 flex items-center justify-center cursor-pointer relative">
              <i className="ri-heart-line text-xl"></i>
              {wishlistTotal > 0 && (
                <span className="absolute -top-1 -right-1 w-5 h-5 bg-black text-white text-xs flex items-center justify-center rounded-full">
                  {wishlistTotal}
                </span>
              )}
            </Link>
            <Link to="/cart" className="w-10 h-10 flex items-center justify-center cursor-pointer relative">
              <i className="ri-shopping-bag-line text-xl"></i>
              {totalItems > 0 && (
                <span className="absolute -top-1 -right-1 w-5 h-5 bg-black text-white text-xs flex items-center justify-center rounded-full">
                  {totalItems}
                </span>
              )}
            </Link>
          </div>
        </div>

        {/* Mobile Menu Dropdown */}
        {mobileMenuOpen && (
          <div className="md:hidden border-t border-black/10 bg-white">
            <div className="px-6 py-4 flex flex-col gap-4">
              <Link to="/shop" className="text-sm tracking-[0.2em] hover:opacity-60 transition-opacity cursor-pointer" onClick={() => setMobileMenuOpen(false)}>NEW ARRIVALS</Link>
              <div>
                <button 
                  onClick={() => setCollectionDropdownOpen(!collectionDropdownOpen)}
                  className="text-sm tracking-[0.2em] hover:opacity-60 transition-opacity cursor-pointer flex items-center gap-1 w-full"
                >
                  COLLECTION
                  <i className={`ri-arrow-${collectionDropdownOpen ? 'up' : 'down'}-s-line text-lg`}></i>
                </button>
                {collectionDropdownOpen && (
                  <div className="pl-4 mt-2 space-y-2">
                    <Link to="/shop?category=hoodies" className="block text-sm tracking-[0.2em] text-neutral-600 hover:opacity-60 transition-opacity cursor-pointer" onClick={() => setMobileMenuOpen(false)}>
                      HOODIES
                    </Link>
                    <Link to="/shop?category=tees" className="block text-sm tracking-[0.2em] text-neutral-600 hover:opacity-60 transition-opacity cursor-pointer" onClick={() => setMobileMenuOpen(false)}>
                      T-SHIRTS
                    </Link>
                  </div>
                )}
              </div>
              <Link to="/about" className="text-sm tracking-[0.2em] hover:opacity-60 transition-opacity cursor-pointer" onClick={() => setMobileMenuOpen(false)}>ABOUT</Link>
              <div className="flex gap-4 pt-4 border-t border-black/10">
                <button 
                  onClick={() => {
                    setSearchModalOpen(true);
                    setMobileMenuOpen(false);
                  }}
                  className="w-10 h-10 flex items-center justify-center cursor-pointer"
                >
                  <i className="ri-search-line text-xl"></i>
                </button>
                <Link to="/wishlist" className="w-10 h-10 flex items-center justify-center cursor-pointer relative" onClick={() => setMobileMenuOpen(false)}>
                  <i className="ri-heart-line text-xl"></i>
                  {wishlistTotal > 0 && (
                    <span className="absolute -top-1 -right-1 w-5 h-5 bg-black text-white text-xs flex items-center justify-center rounded-full">
                      {wishlistTotal}
                    </span>
                  )}
                </Link>
              </div>
            </div>
          </div>
        )}
      </nav>

      {/* Terms Content */}
      <div className="pt-32 pb-24 px-6">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-3xl md:text-5xl font-light tracking-[0.15em] md:tracking-[0.2em] mb-6 md:mb-8" style={{ fontFamily: '"Playfair Display", serif' }}>
            TERMS OF SERVICE
          </h1>
          <p className="text-xs md:text-sm text-neutral-600 mb-12 md:mb-16">Last updated: January 1, 2024</p>

          <div className="prose prose-neutral max-w-none">
            <section className="mb-12">
              <h2 className="text-xl md:text-2xl font-light tracking-[0.1em] mb-4 md:mb-6" style={{ fontFamily: '"Playfair Display", serif' }}>
                Agreement to Terms
              </h2>
              <div className="space-y-4 text-sm leading-relaxed">
                <p>By accessing and using DASHY Fashion website, you accept and agree to be bound by the terms and provision of this agreement.</p>
              </div>
            </section>

            <section className="mb-12">
              <h2 className="text-xl md:text-2xl font-light tracking-[0.1em] mb-4 md:mb-6" style={{ fontFamily: '"Playfair Display", serif' }}>
                Use License
              </h2>
              <div className="space-y-4 text-sm leading-relaxed">
                <p>Permission is granted to temporarily download one copy of the materials on DASHY Fashion's website for personal, non-commercial transitory viewing only.</p>
                <p>This is the grant of a license, not a transfer of title, and under this license you may not:</p>
                <ul className="list-disc pl-6 space-y-2">
                  <li>modify or copy the materials</li>
                  <li>use the materials for any commercial purpose or for any public display</li>
                  <li>attempt to reverse engineer any software contained on the website</li>
                  <li>remove any copyright or other proprietary notations from the materials</li>
                </ul>
              </div>
            </section>

            <section className="mb-12">
              <h2 className="text-xl md:text-2xl font-light tracking-[0.1em] mb-4 md:mb-6" style={{ fontFamily: '"Playfair Display", serif' }}>
                Product Information
              </h2>
              <div className="space-y-4 text-sm leading-relaxed">
                <p>We strive to provide accurate product information, including descriptions, pricing, and availability. However, we do not warrant that product descriptions or other content is accurate, complete, reliable, current, or error-free.</p>
              </div>
            </section>

            <section className="mb-12">
              <h2 className="text-xl md:text-2xl font-light tracking-[0.1em] mb-4 md:mb-6" style={{ fontFamily: '"Playfair Display", serif' }}>
                Orders and Payment
              </h2>
              <div className="space-y-4 text-sm leading-relaxed">
                <p>By placing an order, you are making an offer to purchase products subject to these Terms of Service. We reserve the right to refuse or cancel any order for any reason.</p>
                <p>Payment must be received in full before products are shipped. We accept major credit cards and other payment methods as displayed during checkout.</p>
              </div>
            </section>

            <section className="mb-12">
              <h2 className="text-xl md:text-2xl font-light tracking-[0.1em] mb-4 md:mb-6" style={{ fontFamily: '"Playfair Display", serif' }}>
                Shipping and Returns
              </h2>
              <div className="space-y-4 text-sm leading-relaxed">
                <p>We aim to process and ship orders within 1-3 business days. Shipping times may vary based on location and shipping method selected.</p>
                <p>Returns are accepted within 30 days of delivery for unworn, unwashed items with original tags attached. Return shipping costs are the responsibility of the customer unless the item was defective or incorrectly shipped.</p>
              </div>
            </section>

            <section className="mb-12">
              <h2 className="text-xl md:text-2xl font-light tracking-[0.1em] mb-4 md:mb-6" style={{ fontFamily: '"Playfair Display", serif' }}>
                Disclaimer
              </h2>
              <div className="space-y-4 text-sm leading-relaxed">
                <p>The materials on DASHY Fashion's website are provided on an 'as is' basis. DASHY Fashion makes no warranties, expressed or implied, and hereby disclaims and negates all other warranties including without limitation, implied warranties or conditions of merchantability, fitness for a particular purpose, or non-infringement of intellectual property or other violation of rights.</p>
              </div>
            </section>

            <section className="mb-12">
              <h2 className="text-xl md:text-2xl font-light tracking-[0.1em] mb-4 md:mb-6" style={{ fontFamily: '"Playfair Display", serif' }}>
                Limitations
              </h2>
              <div className="space-y-4 text-sm leading-relaxed">
                <p>In no event shall DASHY Fashion or its suppliers be liable for any damages (including, without limitation, damages for loss of data or profit, or due to business interruption) arising out of the use or inability to use the materials on DASHY Fashion's website, even if DASHY Fashion or an authorized representative has been notified orally or in writing of the possibility of such damage.</p>
              </div>
            </section>

            <section className="mb-12">
              <h2 className="text-xl md:text-2xl font-light tracking-[0.1em] mb-4 md:mb-6" style={{ fontFamily: '"Playfair Display", serif' }}>
                Revisions and Errata
              </h2>
              <div className="space-y-4 text-sm leading-relaxed">
                <p>The materials appearing on DASHY Fashion's website could include technical, typographical, or photographic errors. DASHY Fashion does not warrant that any of the materials on its website are accurate, complete, or current.</p>
              </div>
            </section>

            <section className="mb-12">
              <h2 className="text-xl md:text-2xl font-light tracking-[0.1em] mb-4 md:mb-6" style={{ fontFamily: '"Playfair Display", serif' }}>
                Contact Information
              </h2>
              <div className="space-y-4 text-sm leading-relaxed">
                <p>If you have any questions about these Terms of Service, please contact us at:</p>
                <p className="font-medium">support@dashyfashion.com</p>
              </div>
            </section>
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer className="bg-black text-white py-16 px-6">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
            <div>
              <h3 className="text-sm tracking-[0.2em] mb-6">DASHY</h3>
              <p className="text-sm text-neutral-400 leading-relaxed">
                Quiet luxury streetwear with meaningful messages for the modern individual.
              </p>
            </div>
            
            <div>
              <h4 className="text-sm tracking-[0.2em] mb-4">SHOP</h4>
              <ul className="space-y-3 text-sm text-neutral-400">
                <li><Link to="/shop" className="hover:text-white transition-colors cursor-pointer">New Arrivals</Link></li>
                <li><Link to="/shop" className="hover:text-white transition-colors cursor-pointer">Hoodies</Link></li>
                <li><Link to="/shop" className="hover:text-white transition-colors cursor-pointer">T-Shirts</Link></li>
                <li><Link to="/shop" className="hover:text-white transition-colors cursor-pointer">Collections</Link></li>
              </ul>
            </div>
            
            <div>
              <h4 className="text-sm tracking-[0.2em] mb-4">COMPANY</h4>
              <ul className="space-y-3 text-sm text-neutral-400">
                <li><Link to="/about" className="hover:text-white transition-colors cursor-pointer">About Us</Link></li>
                <li><Link to="/contact" className="hover:text-white transition-colors cursor-pointer">Contact Us</Link></li>
              </ul>
            </div>
            
            <div>
              <h4 className="text-sm tracking-[0.2em] mb-4">FOLLOW US</h4>
              <div className="flex gap-4">
                <a href="https://instagram.com/Dashyfashionofficial" target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center border border-white/20 hover:bg-white hover:text-black transition-all cursor-pointer">
                  <i className="ri-instagram-line text-lg"></i>
                </a>
              </div>
            </div>
          </div>
          
          <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-neutral-400">
            <div className="flex items-center gap-3">
              <p>© 2024 All rights reserved.</p>
            </div>
            <div className="flex gap-6">
              <Link to="/privacy" className="hover:text-white transition-colors cursor-pointer">Privacy Policy</Link>
              <Link to="/terms" className="hover:text-white transition-colors cursor-pointer">Terms of Service</Link>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}
